import { TextField } from '@material-ui/core';
import React from 'react';
import { Row, Col, Image } from 'react-bootstrap';

const Pricing = ({ formik }) => {
  const handleTypeChange = (type) => {
    let newTypes;
    if (formik.values.selectedTypes.includes(type)) {
      newTypes = formik.values.selectedTypes.filter((t) => t !== type);
    } else {
      newTypes = [...formik.values.selectedTypes, type];
    }
    formik.setFieldValue('selectedTypes', newTypes);
  };

  const handlePriceChange = (type, field, value) => {
    formik.setFieldValue(`pricing.${type}.${field}`, value);
  };

  const getIconStyle = (type) => {
    return formik.values.selectedTypes.includes(type)
      ? {
          border: '2px solid #ee3a23', // Blue border when selected
          borderRadius: '50%', // Rounded border
          padding: '4px', // Add some padding
        }
      : '';
  };

  return (
    <div>
      <h5 className="my-2">Order Type</h5>
      <p className="my-2">Select in which all order types menu is available.</p>
      <div className="d-flex mb-3">
        <Image
          src={require('../../../../../../../../assets/images/seatingImages/takeawayicon.svg')}
          alt="Take Away"
          className={`order-type-icon ${
            formik.values.selectedTypes.includes('takeAway')
              ? 'selected-icon'
              : ''
          }`}
          onClick={() => handleTypeChange('takeAway')}
          style={{
            cursor: 'pointer',
            marginRight: '10px',
            width: '50px',
            height: '50px',
            ...getIconStyle('takeAway'),
          }}
          rounded
        />
        <Image
          src={require('../../../../../../../../assets/images/seatingImages/curbsideicon.svg')}
          alt="Curb Side"
          className={`order-type-icon ${
            formik.values.selectedTypes.includes('curbSide')
              ? 'selected-icon'
              : ''
          }`}
          onClick={() => handleTypeChange('curbSide')}
          style={{
            cursor: 'pointer',
            marginRight: '10px',
            width: '50px',
            height: '50px',
            ...getIconStyle('curbSide'),
          }}
          rounded
        />
        <Image
          src={require('../../../../../../../../assets/images/superadmin/ordericon/skipTheLine.svg')}
          alt="Skip-The Line"
          className={`order-type-icon ${
            formik.values.selectedTypes.includes('skipTheLine')
              ? 'selected-icon'
              : ''
          }`}
          onClick={() => handleTypeChange('skipTheLine')}
          style={{
            cursor: 'pointer',
            marginRight: '10px',
            width: '50px',
            height: '50px',
            ...getIconStyle('skipTheLine'),
          }}
          rounded
        />
        <Image
          src={require('../../../../../../../../assets/images/superadmin/ordericon/dineOrder.svg')}
          alt="Dine-In"
          className={`order-type-icon ${
            formik.values.selectedTypes.includes('dineIn')
              ? 'selected-icon'
              : ''
          }`}
          onClick={() => handleTypeChange('dineIn')}
          style={{
            cursor: 'pointer',
            marginRight: '10px',
            width: '50px',
            height: '50px',
            ...getIconStyle('dineIn'),
          }}
          rounded
        />
        <Image
          src={require('../../../../../../../../assets/images/superadmin/ordericon/delivery.svg')}
          alt="Delivery"
          className={`order-type-icon ${
            formik.values.selectedTypes.includes('delivery')
              ? 'selected-icon'
              : ''
          }`}
          onClick={() => handleTypeChange('delivery')}
          style={{ cursor: 'pointer', width: '50px', height: '50px' }}
          rounded
        />
      </div>

      {/* Render pricing fields dynamically based on selected order types */}
      {formik.values.selectedTypes.map((type) => (
        <div key={type}>
          {/* <h6 className="mt-4">
            Combo Price for {type.charAt(0).toUpperCase() + type.slice(1)}
          </h6> */}
          <Row className="w-75 my-2">
            <Col md={2} className="f14-500 text-center pt-2">
              {type.charAt(0).toUpperCase() + type.slice(1)}
            </Col>
            <Col md={4}>
              <TextField
                label="List Price"
                type="number"
                name={`pricing.${type}.listPrice`}
                value={formik.values.pricing[type].listPrice}
                onChange={(e) =>
                  handlePriceChange(type, 'listPrice', e.target.value)
                }
                fullWidth
                variant="outlined"
                error={
                  formik.touched.pricing?.[type]?.listPrice &&
                  Boolean(formik.errors.pricing?.[type]?.listPrice)
                }
                helperText={
                  formik.touched.pricing?.[type]?.listPrice &&
                  formik.errors.pricing?.[type]?.listPrice
                }
              />
            </Col>
            <Col md={2}>
              <TextField
                label="Combo Price"
                type="number"
                name={`pricing.${type}.comboPrice`}
                value={formik.values.pricing[type].comboPrice}
                onChange={(e) =>
                  handlePriceChange(type, 'comboPrice', e.target.value)
                }
                fullWidth
                variant="outlined"
                error={
                  formik.touched.pricing?.[type]?.comboPrice &&
                  Boolean(formik.errors.pricing?.[type]?.comboPrice)
                }
                helperText={
                  formik.touched.pricing?.[type]?.comboPrice &&
                  formik.errors.pricing?.[type]?.comboPrice
                }
              />
            </Col>
            <Col md={2}>
              <TextField
                label="Packing Charges"
                type="number"
                name={`pricing.${type}.packingCharges`}
                value={formik.values.pricing[type].packingCharges}
                onChange={(e) =>
                  handlePriceChange(type, 'packingCharges', e.target.value)
                }
                fullWidth
                variant="outlined"
                error={
                  formik.touched.pricing?.[type]?.packingCharges &&
                  Boolean(formik.errors.pricing?.[type]?.packingCharges)
                }
                helperText={
                  formik.touched.pricing?.[type]?.packingCharges &&
                  formik.errors.pricing?.[type]?.packingCharges
                }
              />
            </Col>
          </Row>
        </div>
      ))}
    </div>
  );
};

export default Pricing;
